import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=f5178c50&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=f5178c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5178c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5178c50')) {
      api.createRecord('f5178c50', component.options)
    } else {
      api.reload('f5178c50', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=f5178c50&scoped=true&", function () {
      api.rerender('f5178c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VYNnpf7hkKW1/JS/teamMember.vue"
export default component.exports